(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/definitions/topptipset.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/definitions/topptipset.js'); "use strict";

let makeXpertSizes;
let productIds;
let EventTypeId;
let constants;
let brandMapping;
let isSelfService;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  constants = require('../constants.es6');
  makeXpertSizes = require('../utils/make-xpert-sizes.es6');
  productIds = require('trinidad-core').core.components.require('utils', 'products').productIds;
  EventTypeId = require('../../../../../sportinfo/common/assets/javascripts/constants.es6').EventTypeId;
  brandMapping = require('../../../../../lb-utils/brand-mapping/assets/javascripts/brand-mapping.es6');
  isSelfService = trinidad.config.options.isSelfService;
} else {
  var _svs$core$config$data;
  makeXpertSizes = svs.components.tipsen.engine.utils.makeXpertSizes;
  productIds = svs.utils.products.productIds;
  EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
  constants = svs.components.tipsen.engine.constants;
  brandMapping = svs.components.lbUtils.brandMapping.fn;
  isSelfService = (_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService;
}
const TypesRelatedProducts = {
  [constants.RelatedProductType.PIX]: {
    [productIds.T8STRYK]: productIds.FULLTRAFF,
    [productIds.T8]: null,
    [productIds.T8EXTRA]: null
  }
};
const topptipsetDefinition = {
  competitions: [],
  outcomes: {
    eventTypeId: EventTypeId.EVENT_1X2
  },
  rSystems: [],
  uSystems: [],
  systems: [constants.systems.SYSTEM_MSYS],
  betAmounts: [1, 2, 3, 5, 10],
  weeks: [1],
  sportkryssFactors: [0],
  sportkryssBase: 10,
  addonPixSize: [0, 16, 32, 64],
  maxSystemSize: 4374,
  drawProductIds: [productIds.T8, productIds.T8EXTRA, productIds.T8STRYK],
  xpertMsys: makeXpertSizes(8, 8, 2, 972),
  xpertMsysSpecialValues: [16, 24, 32, 36, 64, 81, 96, 192, 243],
  quickPlayPixSizes: [16, 48, 72, 108, 144, 192, 216, 384],
  displayName: brandMapping.getProductDisplayName(productIds.T8),
  brandName: brandMapping.getSiteBrand(productIds.T8),
  brandLogo: brandMapping.getProductBrand(productIds.T8),
  competitionId: brandMapping.getProductCompetitionId(productIds.T8),
  getDisplayNameByDraw: draw => brandMapping.getProductDisplayNameByDraw(draw, productIds.T8),
  getBrandNameByDraw: draw => brandMapping.getSiteBrandByDraw(draw, productIds.T8),
  getBrandNamesByDraw: draw => brandMapping.getProductBrandsByDraw(draw, productIds.T8),
  getBrandLogoByDraw: draw => brandMapping.getProductBrandByDraw(draw, productIds.T8),
  getBrandMenuColorByDraw: draw => brandMapping.getProductBrandMenuColorByDraw(draw, productIds.T8),
  maxExternalSystemSize: 4374,
  features: {
    marketplace: true,
    singles: true
  },
  getRelatedProduct: (type, productId) => TypesRelatedProducts[type][productId],
  getTransfer: draw => {
    if (draw.productId === productIds.T8) {
      return null;
    }
    return {
      product: draw.productId === productIds.T8STRYK ? productIds.STRYKTIPSET : productIds.EUROPATIPSET,
      drawsApi: draw.productId === productIds.T8STRYK ? 'stryktipset' : 'europatipset'
    };
  },
  minGroupAmount: 10,
  minStake: 1,
  hasGuaranteedJackpot: false,
  hasJackpot: false,
  tipsinfoSupport: [constants.tipsinfo.Odds, constants.tipsinfo.StartOdds, constants.tipsinfo.SvenskaFolket, constants.tipsinfo.Matchstart, constants.tipsinfo.Favourites, constants.tipsinfo.Mutuals, constants.tipsinfo.Analys],
  tipsinfoSupportResult: [constants.tipsinfo.Odds, constants.tipsinfo.SvenskaFolket, constants.tipsinfo.Favourites],
  loadDrawsApiPath: 'topptipsetfamily',
  moduleEngine: 'topptipset',
  defaultCouponValues: {
    betAmountIndex: 0,
    pixSize: 72,
    reduceModeCount: undefined
  },
  pixSystem: constants.PixSystem.Xperten,
  externalChunkSize: {
    SROW: 1000,
    MSYS: 100,
    SROW_MARKETPLACE_GROUP: 1000,
    MSYS_MARKETPLACE_GROUP: 100 
  },

  couponSettings: [constants.coupon.Compressed]
};
if (isSelfService) {
  topptipsetDefinition.defaultCouponValues.betAmountIndex = 1;
}
if (svs.isServer) {
  module.exports = topptipsetDefinition;
} else {
  setGlobal('svs.components.tipsen.engine.definitions.topptipset', topptipsetDefinition);
}
 })(window);